import React from 'react'
import { Outlet } from 'react-router-dom';

const Expertise = () => {
    return (
        <div>
            <h1>Our Expertise</h1>
            <Outlet />
        </div>
    );
};

export default Expertise;